export enum ClpPopulation {
  AUTO = 'auto',
  NAME = 'clp_population',
  QUERY = 'query',
}

/**
 * Sends a refreshed page event when a customer soft-navigates between taxonomy
 * PLPs. Off until GTM is confirmed to be safe against double-counting page
 * views. See DISC-4541.
 */
export enum TaxonomySoftNavPageEvent {
  NAME = 'tplp_soft_nav_page_event',
  OFF = 'off',
  ON = 'on',
}
